export type AiConversationResult = "Done" | "ActionRequired";